import { useState } from 'react';
import { usePage } from '@inertiajs/react';
import type { SharedData } from '@/types';

export function useFavourites() {
    const { favourite_ids } = usePage<SharedData>().props;
    const { auth } = usePage<SharedData>().props;

    const [ids, setIds] = useState<Set<string>>(
        new Set((favourite_ids ?? []).map(String)),
    );

    const isFavourite = (profileId: string | number): boolean =>
        ids.has(String(profileId));

    const toggle = async (profileId: string | number): Promise<void> => {
        if (!auth?.user) return; // must be logged in

        const id = String(profileId);

        // Optimistic update
        setIds((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });

        const csrf =
            document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
                ?.content ?? '';

        try {
            await fetch(`/p/${profileId}/favourite`, {
                method: 'POST',
                headers: { 'X-CSRF-TOKEN': csrf, Accept: 'application/json' },
            });
        } catch {
            // Revert on network failure
            setIds((prev) => {
                const next = new Set(prev);
                next.has(id) ? next.delete(id) : next.add(id);
                return next;
            });
        }
    };

    return { isFavourite, toggle };
}
